//created by sudip
import { motion } from "framer-motion";

interface TransformationChartProps {
    accent: string;
}

const data = [
    34,
    42,
    55,
    63,
    72,
    84,
    96,
];

const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
];

export function TransformationChart({

    accent,

}: TransformationChartProps) {

    const max = Math.max(...data);

    return (

        <motion.div
            initial={{
                opacity: 0,
                y: 24,
            }}
            animate={{
                opacity: 1,
                y: 0,
            }}
            transition={{
                duration: 0.6,
                delay: 0.45,
            }}
            className="
                mt-5
                rounded-3xl
                border
                border-slate-200
                bg-white
                p-4
                shadow-sm
            "
        >

            <div className="flex items-start justify-between">

                <div>

                    <p className="text-sm font-semibold text-slate-500">

                        Business Transformation Index

                    </p>

                    <h3 className="mt-1 text-2xl font-bold text-slate-900">

                        +42%

                    </h3>

                </div>

                <span
                    className="rounded-full px-3 py-1 text-xs font-semibold"
                    style={{
                        backgroundColor: `${accent}18`,
                        color: accent,
                    }}
                >

                    ● Live

                </span>

            </div>

            <div className="relative mt-6">

                {/* subtle grid */}

                <div className="absolute inset-0">

                    {[0,1,2,3].map((i)=>(
                        <div
                            key={i}
                            className="h-1/4 border-t border-dashed border-slate-100"
                        />
                    ))}

                </div>

                <div className="relative flex h-40 items-end justify-between gap-3">

                    {data.map((value,index)=>(

                        <div
                            key={months[index]}
                            className="flex flex-1 flex-col items-center"
                        >

                            <motion.div
                                initial={{
                                    height:0,
                                }}
                                animate={{
                                    height:`${(value/max)*170}px`,
                                }}
                                transition={{
                                    duration:0.8,
                                    delay:index*0.08,
                                }}
                                className="
                                    w-full
                                    rounded-t-2xl
                                "
                                style={{
                                    background:
                                        `linear-gradient(180deg,
                                        ${accent},
                                        ${accent}88)`,
                                }}
                            />

                            <span className="mt-3 text-xs text-slate-500">

                                {months[index]}

                            </span>

                        </div>

                    ))}

                </div>

            </div>

            <div className="mt-6 flex items-center justify-between">

                <div className="flex items-center gap-2">

                    <span
                        className="h-3 w-3 rounded-full"
                        style={{
                            backgroundColor:accent,
                        }}
                    />

                    <span className="text-sm text-slate-600">

                        AI Adoption

                    </span>

                </div>

                <span className="text-sm text-slate-500">

                    Updated 2 min ago

                </span>

            </div>

        </motion.div>

    );

}